export default class BaseInfo {
  id: number = 0
  createAt: number = 0
  sortName: string[] = []
  sortOrder: string = ''
}
